var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlannerPersonalinfoIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103 49.5C103 76.8381 80.8381 99 53.5 99C26.1619 99 4 76.8381 4 49.5C4 22.1619 26.1619 0 53.5 0C80.8381 0 103 22.1619 103 49.5Z",
    fill: "#8C857B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.407 30.5803H23.5918V69.4196H86.407V30.5803Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4277 39.4486H79.9024",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4277 46.3087H79.9024",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4277 53.1514H79.9024",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4277 60.0232H79.9024",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6996 53.9523L45.7166 52.0081C45.357 52.2576 44.9766 52.477 44.5793 52.6639C43.5541 53.1529 42.4289 53.407 41.2887 53.407C40.1485 53.407 39.0232 53.1529 37.998 52.6639C37.6007 52.477 37.2203 52.2576 36.8607 52.0081L30.8777 53.9523C30.6514 54.0311 30.4548 54.1754 30.3141 54.3661C30.1734 54.5569 30.0952 54.785 30.0898 55.0202V61.091C30.0898 61.2386 30.1196 61.3848 30.1774 61.5211C30.2353 61.6573 30.32 61.7811 30.4268 61.8852C30.5336 61.9893 30.6603 62.0717 30.7997 62.1276C30.9391 62.1836 31.0884 62.212 31.239 62.2112H51.3323C51.4827 62.212 51.6317 62.1835 51.7708 62.1275C51.9098 62.0715 52.0362 61.989 52.1425 61.8848C52.2488 61.7807 52.333 61.6569 52.3902 61.5206C52.4474 61.3844 52.4764 61.2384 52.4756 61.091V55.0202C52.4712 54.7864 52.3947 54.5593 52.2562 54.3687C52.1177 54.1781 51.9237 54.033 51.6996 53.9523Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2914 51.5437C44.7854 51.5437 47.6179 48.3866 47.6179 44.4921C47.6179 40.5976 44.7854 37.4404 41.2914 37.4404C37.7973 37.4404 34.9648 40.5976 34.9648 44.4921C34.9648 48.3866 37.7973 51.5437 41.2914 51.5437Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 0,
    y: 0,
    width: 107,
    height: 107,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlannerPersonalinfoIcon);
export default __webpack_public_path__ + "static/media/planner-personalinfo-icon.5e035b567557c9be968a93eb32bfd08d.svg";
export { ForwardRef as ReactComponent };